import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useQueryParamTerm, useQueryParamsEffect } from 'pricing-pages-ui/utils/urls/appQueryParamUtils';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { FaqsConfig } from '../../../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import Screens from '../../../constants/routing/Screens';
import { useAnchorLinkScroll } from '../../../hooks/htmlElementHooks';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import { usePageParams } from '../../../hooks/usePageParams';
import { useTrackRetail } from '../../../hooks/useTrackRetail';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../../selectors/LoadingStateSelectors';
import BannerSection from '../../banners/BannerSection';
import CustomerSupport from '../../common/CustomerSupport';
import IntegrationsSection from '../../common/Integrations';
import PhoneSupport from '../../common/PhoneSupport';
import PhoneSupportFooter from '../../common/PhoneSupportFooter';
import ProductInfoContainer from '../../common/ProductInfoContainer';
import CodeSplitEnvWrapper from '../../common/env/CodeSplitEnvWrapper';
import FailedLoadBanner from '../../common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../../common/loading/FallbackErrorBanner';
import CompareStatusFooter from '../../compare/CompareStatusFooter';
import Faq from '../../faqs/Faq';
import FooterMicrocopy from '../../faqs/FooterMicrocopy';
import Question from '../../faqs/Question';
import SegmentedTabs from '../../layout/tabs/SegmentedTabs';
import ProductPageSubtitle from '../../product-pages/ProductPageSubtitle';
import ProductPageTitle, { ProductPageHeader } from '../../product-pages/ProductPageTitle';
import MobileCurrencyPicker from '../MobileCurrencyPicker';
import MobileDropdownNav from '../MobileDropdownNav';
import MobileWhyGoHubSpotSection from '../MobileWhyGoHubSpotSection';
import MobileSuiteTileContainer from './MobileSuiteTileContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuitePage = () => {
  useAnchorLinkScroll();
  useTrackRetail();
  useDocumentTitle('crmSuite');
  const isAppAuth = useSelector(isAppAuthSelector);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  const {
    tab
  } = usePageParams();
  const [selectedTab, setSelectedTab] = useState(tab);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: Screens.SUITE,
      tab: selectedTab
    });
  }, [selectedTab]);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
      name: "SUITE_PAGE"
    }), !isAppAuth && /*#__PURE__*/_jsx(SegmentedTabs, {
      selectedTab: selectedTab,
      setTab: setSelectedTab,
      path: "/suite",
      bordered: true,
      use: "enclosed"
    }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
      selectedNavItem: NavItemEnum.SUITE
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      children: [/*#__PURE__*/_jsx(BannerSection, {
        screen: Screens.SUITE,
        navItem: NavItemEnum.SUITE
      }), /*#__PURE__*/_jsx(FailedLoadBanner, {
        hasFailed: hasPricingAndPurchasingFailed
      }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(ProductPageHeader, {
        children: [/*#__PURE__*/_jsx(ProductPageTitle, {
          nonProductIdentifier: NavItemEnum.SUITE
        }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
          nonProductIdentifier: NavItemEnum.SUITE
        })]
      }), /*#__PURE__*/_jsx(MobileSuiteTileContainer, {
        selectedTab: selectedTab
      }), /*#__PURE__*/_jsx(PhoneSupport, {
        phoneSourceId: "crmsuite-middle",
        screen: Screens.SUITE
      }), /*#__PURE__*/_jsx(MobileWhyGoHubSpotSection, {
        selectedNavItem: NavItemEnum.SUITE
      }), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
        publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/company-proof/CompanyProof`),
        publicComponentProps: {
          tab: selectedTab
        }
      }), /*#__PURE__*/_jsx(CustomerSupport, {}), /*#__PURE__*/_jsxs(Faq, {
        children: [FaqsConfig[NavItemEnum.SUITE].map(_ref => {
          let {
              questionKey
            } = _ref,
            passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
        phoneSourceId: "crmsuite-footer",
        screen: Screens.SUITE
      })]
    }), /*#__PURE__*/_jsx(CompareStatusFooter, {})]
  });
};
export default MobileSuitePage;